import React, { useEffect, useState } from "react";

import { Card, CardHeader } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import { LanguageContext } from "App";

import Swal from "sweetalert2";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import CreateMultiPackageReq from "../../../../Classes/Models/Requests/AccountingSessions/CreateMultiPackageReq";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import PatientSelector from "CinicComponents/PatientSelector";
import MultiPackageSession from "./MultiPackageSession";
import "./style.scss";

const index = () => {
  const navigate = useNavigate();
  const { translations } = useContext(LanguageContext);

  const [Name, setName] = useState("");
  const [Patient, setPatient] = useState({});
  const [PackageSessions, setSessionIdsAndQuantities] = useState([]);
  const [SessionsCount, setSessionsCount] = useState(1);
  const [TotalOriginalPrice, setTotalOriginalPrice] = useState(0);
  const [TotalQuantity, setTotalQuantity] = useState(0);
  const [TotalFinalPrice, setTotalFinalPrice] = useState(0);
  const [TotalDiscount, setTotalDiscount] = useState(0);

  const onSubtractSessionClick = () => {
    if (SessionsCount > 1) {
      setSessionsCount(SessionsCount - 1);
    } else {
      Swal.fire({
        title: "Error",
        text: "You cannot remove all sessions",
        icon: "error",
      });
    }
  };

  const onCreateClick = async () => {
    Swal.fire({
      title: "Creating Multi-Package...",
      icon: "info",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    if (!Name) {
      Swal.fire({
        title: "error",
        text: translations.PleaseEnterPackageNameandpatient,
        icon: "error",
        confirmButtonText: "ok",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    console.log(Object.keys(Patient));
    console.log(PackageSessions);
    if (Object.keys(Patient).length === 0) {
      Swal.fire({
        title: "error",
        // text: translations.PleaseSelectPatient,
        text: "Please Select a Patient",
        icon: "error",
        confirmButtonText: "ok",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    if (PackageSessions.length === 0) {
      Swal.fire({
        title: "error",
        text: "Please Add Sessions",
        icon: "error",
        confirmButtonText: "ok",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    let req = new CreateMultiPackageReq();
    req.packageName = Name;
    req.packageSessions = PackageSessions;
    req.patientId = Patient.getPatient.id;
    console.log("SENDING");
    let res = await SessionsApi.CreateMultiPackage(req);
    console.log("Seent");
    console.log(res);
    console.log("Seent2");

    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
        confirmButtonText: "OK",
        didOpen: () => {
          Swal.hideLoading();
        },
      }).then(() => {
        navigate("/AccountingSessions/Packages/Details/", { state: { pkg: res.data } });
      });
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };
  const ShowPricing = () => {
    return (
      <div className="quantity-discount">
        <MDTypography variant="h6" style={{ marginTop: "10px" }}>
          {translations.createmultiPackageTotalQuantity}: {TotalQuantity}
        </MDTypography>
        <MDTypography variant="h6" style={{ marginTop: "10px" }}>
          {translations.createmultiPackageTotalOriginalPrice}: {TotalOriginalPrice}
        </MDTypography>
        <MDTypography variant="h6" style={{ marginTop: "10px" }}>
          {translations.createmultiPackageTotalDiscount}: {TotalDiscount.toFixed(2)}%
        </MDTypography>

        <MDTypography variant="h6" className="final-price" style={{ marginTop: "10px" }}>
          {translations.createmultiPackageTotalFinalPrice}: {TotalFinalPrice}
        </MDTypography>
      </div>
    );
  };
  const setPkgSession = (pkgSession, index) => {
    let newPackageSessions = [...PackageSessions];
    newPackageSessions[index] = pkgSession;
    setSessionIdsAndQuantities(newPackageSessions);
  };

  useEffect(() => {
    if (PackageSessions.length > 0) {
      let totalQuantity = 0;
      let totalOriginalPrice = 0;
      let totalFinalPrice = 0;
      for (let i = 0; i < PackageSessions.length; i++) {
        totalQuantity += PackageSessions[i].quantity;
        totalOriginalPrice += PackageSessions[i].originalPrice * PackageSessions[i].quantity;
        totalFinalPrice += PackageSessions[i].finalPrice * PackageSessions[i].quantity;
        // totalSessionsTypes++;
      }
      let totalDiscount = (100 * (totalOriginalPrice - totalFinalPrice)) / totalOriginalPrice;
      setTotalQuantity(totalQuantity);
      setTotalOriginalPrice(totalOriginalPrice);
      setTotalFinalPrice(totalFinalPrice);
      setTotalDiscount(totalDiscount);
    }
  }, [PackageSessions]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card sx={{ padding: "1em" }}>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.createmultiPackageCreateMultiPackage}
          </MDTypography>
          <MDButton
            color="primary"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            onClick={() => onCreateClick()}
          >
            <Icon>add</Icon>
            &nbsp;{translations.createmultiPackageCreateMultiPackage}
          </MDButton>
        </MDBox>

        {/*  <div className={translations.setlang === "ar" ? "rtl-label" : ""}> */}
        <div className="container-fluid mt-4">
          <div>
            <div className="pacakge-header">
              <div className="col-8 pacakge-patient">
                <MDInput
                  className="pacakge "
                  label={translations.createmultiPackagePackageName}
                  onChange={(e) => setName(e.target.value)}
                  type={"text"}
                  fullWidth
                ></MDInput>

                <PatientSelector
                  className={translations.setlang === "ar" ? "rtl-label" : ""}
                  Patient={Patient}
                  setPatient={setPatient}
                  fullWidth
                />
              </div>
              <div className="price">{ShowPricing()}</div>
            </div>
            {/* </div> */}

            <div className="col-md-4 mt-4">
              <MDTypography mr={3} variant="button" fontWeight="regular" color="text">
                {SessionsCount} {translations.createmultiPackageSessions}
              </MDTypography>
              <MDButton
                sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                color="text"
                onClick={() => setSessionsCount(SessionsCount + 1)}
              >
                <Icon>add</Icon>
              </MDButton>
            </div>

            <div className="col-md-12 mt-4">
              {Array.from(Array(SessionsCount).keys()).map((i) => {
                return (
                  <Card>
                    <MDBox key={i} mb={3}>
                      <MDTypography mr={3} variant="button" fontWeight="regular" color="text">
                        {translations.createmultiPackageSessions} {i + 1}:
                      </MDTypography>

                      <MultiPackageSession
                        Patient={Patient}
                        index={i}
                        setPkgSession={setPkgSession}
                      />
                    </MDBox>
                  </Card>
                );
              })}
            </div>

            <div className="col-md-4"></div>
          </div>
        </div>

        <MDBox mb={3}></MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pt={2}
          px={2}
          mb={3}
        ></MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default index;
